module.exports = __webpack_public_path__ + "img/octopus-gift.0ba5a565.svg";